<ng-container *transloco="let t; read: 'date-range-picker'">
    <div class="flex flex-row space-x-4 w-full rounded border shadow-sm bg-card h-12 items-center px-2">
        <button mat-icon-button (click)="prev()" [disabled]="disabled">
            <mat-icon svgIcon="mat_solid:keyboard_arrow_left"></mat-icon>
        </button>

        <div class="flex">
            <div #periodPickerOrigin class="h-1 w-0"></div>
            <button mat-button (click)="openPicker()" [disabled]="disabled">
                <span [innerHtml]="text"></span>
            </button>
        </div>

        <button mat-icon-button (click)="next()" [disabled]="disabled">
            <mat-icon svgIcon="mat_solid:keyboard_arrow_right"></mat-icon>
        </button>
    </div>

    <ng-template #periodPicker>
        <ng-template #periodPickerHost></ng-template>
    </ng-template>
</ng-container>
